/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForCloudUsageBillingMigration extends models.BackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForCloudUsageBillingMigration");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForCloudUsageBillingMigration.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForCloudUsageBillingMigration>): BackgroundJobPayloadForCloudUsageBillingMigration {
        let obj = Object.assign(new BackgroundJobPayloadForCloudUsageBillingMigration(), model);
        BackgroundJobPayloadForCloudUsageBillingMigration.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForCloudUsageBillingMigration>): BackgroundJobPayloadForCloudUsageBillingMigration {
        if (!model) return null;
        return BackgroundJobPayloadForCloudUsageBillingMigration.newInstance(<BackgroundJobPayloadForCloudUsageBillingMigration> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForCloudUsageBillingMigration) {
        if (!obj) return;

        models.BackgroundJobPayloadForCloudUsageBillingMigration.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForCloudUsageBillingMigration): boolean {
        if (models.BackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForCloudUsageBillingMigration.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Target Cloud Account
     */
    service_account_id: string;

}
